import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-nieuweproducten',
  templateUrl: '../../../../assets/html/fabrikanten_nieuweproducten.html',
  styleUrls: ['./nieuweproducten.component.css']
})
export class NieuweproductenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
